import { cn } from '@/lib/utils';

interface CountBadgeProps {
  /** Number of open, top-level tasks in the group this badge labels. */
  count: number;
  /** What is being counted, for the accessible label (default "tasks"). */
  noun?: string;
  className?: string;
}

/**
 * The small task-count pill shown next to a section, project, or view header.
 * One component so every grouping lens counts the same way and looks the same.
 */
export function CountBadge({ count, noun = 'tasks', className }: CountBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex h-4 min-w-[1.25rem] flex-shrink-0 items-center justify-center rounded-full',
        'bg-muted px-1.5 text-[10px] font-medium tabular-nums text-muted-foreground',
        className,
      )}
      aria-label={`${count} ${count === 1 ? noun.replace(/s$/, '') : noun}`}
      data-testid="count-badge"
    >
      {count}
    </span>
  );
}
